import React from "react";

const NoConnection = ({ isConnected }) =>
    isConnected ? null : (
        <div className="PageHeader__no-connection">No Internet Connection</div>
    );
export default NoConnection;
